import {History} from 'history'
import {Component} from 'react'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

export type Location = {
	pathname: string
	search: string
	hash: string
	state?: any
}

const isElement = (input?: number | Element): input is Element =>
	typeof input === 'object'

export const scrollTo = (
	addOffset: () => number,
	to?: number | Element,
	behaviour?: 'smooth' | 'auto'
): number => {
	const offset = addOffset ? -addOffset() : 0
	const top =
		typeof to === 'number'
			? to + offset
			: !to
			? 0
			: to.getBoundingClientRect().top + pageYOffset + offset
	return window.requestAnimationFrame(() => {
		window.scroll({
			top,
			behavior: behaviour ? behaviour : isElement(to) ? 'smooth' : 'auto'
		})
	})
}

const locationToUrl = ({pathname, search, hash}) => pathname + search + hash

export class ScrollMemory extends Component<{
	location: Location
	history: History
	addOffset?: () => number
}> {
	popped: string
	replaced: string
	url: Map<string, number> = new Map()

	componentDidMount() {
		this.componentWillUnmount = this.props.history.listen(
			(location, action) => {
				switch (action) {
					case 'POP':
						return (this.popped = locationToUrl(location))
					case 'REPLACE':
						return (this.replaced = locationToUrl(location))
				}
			}
		)
	}

	shouldComponentUpdate(nextProps) {
		const {location: actual} = this.props
		const next = nextProps.location
		const key = locationToUrl(actual)
		const locationChanged = key !== locationToUrl(next)
		const sameHashVisited =
			!locationChanged && !!location.hash && next.hash === actual.hash
		if (sameHashVisited) return
		if (!locationChanged) return false
		// save scroll with key location
		this.url.set(key, window.pageYOffset)
	}

	componentDidUpdate() {
		const {location, history, addOffset} = this.props
		const element =
			location.hash &&
			(document.getElementById(location.hash.substring(1)) ||
				document.querySelector(`a[name=${location.hash.substring(1)}]`))
		if (this.replaced === locationToUrl(location)) return
		if (this.popped === locationToUrl(location)) {
			const top = this.url.get(this.popped)
			scrollTo(addOffset, element || top)
			this.popped = undefined
		} else {
			// pass page or element scroll to top
			scrollTo(addOffset, element)
		}
	}

	render() {
		return null
	}
}
